import React from "react";
import Box from '@mui/material/Box';
import './home.css';

const HomeRepr_A = (props) => {
    const imgpath = props.imgaddress;
    const path = 'url(' + imgpath + ')';
    const myStyle={
        backgroundImage: path,
        height:'100vh',
        justifyContent:'center',
        width:'90vw',
        marginTop:'-70px',
        fontSize:'50px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
};
    return (
        <> 
        
        <Box className="r1__boxA" sx={{marginTop:'-1.4%',backgroundColor:'#202020',width:'100vw',maxWidth:'100%',height:'100vh',maxheight:'100%'}}>
        <div className="homeright_A">
            <p>{props.subhead}</p>
            <div className="homeright__img_A">
            <img id='homeright_A' src={imgpath} alt="" />
            </div>
        </div>
        </Box>
        
        <div style={{marginleft:'15%'}} className="split-box2">
       
            <Box  id='white__box2'
                sx={theme => ({ [theme.breakpoints.between(0,600)]:{width: '100vw',height:'50vh',maxHeight:'100%',minHeight:'65vh',maxWidth:'100%',backgroundColor:'white'},           
                [theme.breakpoints.up('md')]:{ width: '50vw',height:'100vh',maxHeight:'50%',maxWidth:'50%',backgroundColor:'white'}
                })}
                
            >
              <div className="homerepr__theory">
                <p>{props.subhead}</p>
                <div>{props.subinfo}</div>
                </div>
            </Box>


            <Box  id='black__box2'
                sx={theme => ({ [theme.breakpoints.between(0,600)]:{width: '100vw',height:'50vh',maxHeight:'100%',maxWidth:'100%',backgroundColor:'#202020'},           
                [theme.breakpoints.up('md')]:{ width: '50vw',height:'100vh',maxHeight:'50%',maxWidth:'50%',backgroundColor:'#202020'}
                })}
            >
            <div className="small_homeright_img_A">
            <img id='small_homeright_A' src={imgpath} alt="error" />
            </div>
            </Box>
        </div>

        
        </>
 );
}
export default HomeRepr_A;